export enum UserRoutes {
  BasePrefix = "user",
  RecoverUser = "recover-user",
  UserStatistics = "UserStatistics"
}
